import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { parseCareerPlayerIds } from "../utils/careerPlayerIds";

/** Primary route playerId + optional ?careerIds=id2,id3 (parent first, then transfers). */
export function useCareerPlayerIds(): string[] {
  const { playerId } = useParams();
  const [searchParams] = useSearchParams();
  const careerIdsQuery = searchParams.get("careerIds");

  return useMemo(
    () => parseCareerPlayerIds(playerId, careerIdsQuery),
    [playerId, careerIdsQuery]
  );
}
